import React from "react";

export const formGroup = {
  idNotifikasi: {value: null},
  tanggalNotifikasiDikirim: {value: null},
  kategoriNotifikasi: {value: null, mandatory: true},
  judulNotifikasi: {value: null, mandatory: true},
  judulMessage: {value: null},
  isiNotifikasi: {value: null, mandatory: true},
  gambarNotifikasiBase64: {value: null},
  dataCustomer: {value: [], mandatory: true},
};

const stripHtmlWithSpacing = (html) => {
  const tempDiv = document.createElement('div');

  const htmlWithSpaces = html
    .replace(/<\/(p|div|br|li|ul|ol|h[1-6])>/gi, ' </$1>')
    .replace(/<(br|hr)\s*\/?>/gi, ' ');

  tempDiv.innerHTML = htmlWithSpaces;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const truncateText = (text, maxLength) => {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

export const tableConfig = {
  customer: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "idNotifikasi",
      label: "ID Notifikasi",
    },
    {
      name: "judulNotifikasi",
      label: "Judul Notifikasi",
    },
    {
      name: "isiNotifikasi",
      label: "Isi Notifikasi",
      options: {
        customBodyRender: (value) => {
          const plainText = stripHtmlWithSpacing(value);
          const truncated = truncateText(plainText, 40);
          return <div dangerouslySetInnerHTML={{ __html: truncated }} />;
        },
      },
    },
    {
      name: "tanggalDikirim",
      label: "Tanggal Dikirim",
    },
    {
      name: "dibuatOleh",
      label: "Dibuat Oleh",
    },
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (val) => {
                    return <>{statusOptions.find(item => item.value === val)?.label || ""}</>
        },
            }
    },
  ],
  system: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "idNotifikasi",
      label: "ID Notifikasi",
    },
    {
      name: "tanggalDikirim",
      label: "Tanggal Dikirim",
    },
    {
      name: "judulNotifikasi",
      label: "Judul Notifikasi",
    },
    {
      name: "isiNotifikasi",
      label: "Isi Notifikasi",
    },
  ],
};

export const kategoriNotifikasiOptions = [
    {label: "INFORMASI", value: "information"},
    {label: "PROMO", value: "promo"},
    {label: "VOUCHER", value: "voucher"},
    {label: "TRANSAKSI", value: "transaction"},
];

const statusOptions = [
    {label: "DRAFT", value: "DRAFT"},
    {label: "SEND", value: "SEND"},
    {label: "DELETED", value: "DELETED"},
];

export const tableConfigListCustomer = [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{tableMeta.rowIndex + 1}</>;
      },
      sort: false,
    },
  },
  {
    name: "memberId",
    label: "Member ID",
        options: {sort: false},
  },
  {
    name: "namaCustomer",
    label: "Nama Customer",
        options: {sort: false, filter: true, search: true},
  },
];
